import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-16 md:py-24 bg-stone-50" aria-label="Dog Boarding Baltimore FAQ">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 font-semibold text-sm px-4 py-1.5 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            Dog Boarding Baltimore – Frequently Asked Questions
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Everything you need to know about our <strong>dog boarding services in Baltimore, MD</strong>.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-xl border border-stone-200 px-6 overflow-hidden data-[state=open]:shadow-lg data-[state=open]:border-amber-200 transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-stone-800 font-semibold hover:text-amber-600 py-5 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
